import * as React from "react"
import { connect } from "react-redux"

import { Action } from "@tenforce/toolbox-button-push-react"
import { Checkbox } from "@tenforce/toolbox-selector-react"
import { Header, HeaderRow, Cell } from "@tenforce/toolbox-table-react"
import { Input, FieldItems } from "@tenforce/toolbox-field-react"

import { formatString } from "../../../../util/Strings"
import { GlobalState } from "../../../../store"
import { mapDispatchToProps, DispatchProps } from "../../actions"
import { Labels } from "../../../../util/Translations"
import { ConceptsInfo } from "../../index"

type StateProps = ConceptsInfo

type Props = StateProps & DispatchProps

export class ConceptTableHeader extends React.Component<Props> {
    render(): JSX.Element {
        const {
            ConceptCode,
            ConceptScreenLabel,
            FilterOnX,
            IncludeInstances,
            WorkspaceCode,
            WorkspaceScreenLabel,
            Active,
        } = Labels

        const {
            filter: { concept, workspace, includeInstances, isActive },
        } = this.props

        return (
            <Header>
                <HeaderRow isCondensed={true}>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={ConceptScreenLabel}
                            >
                                {ConceptScreenLabel}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={ConceptCode}
                            >
                                {ConceptCode}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={WorkspaceScreenLabel}
                            >
                                {WorkspaceScreenLabel}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={WorkspaceCode}
                            >
                                {WorkspaceCode}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={IncludeInstances}
                            >
                                {IncludeInstances}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={Active}
                            >
                                {Active}
                            </Action>
                        </div>
                    </Cell>
                </HeaderRow>
                <HeaderRow>
                    <Cell>
                        <FieldItems>
                            <Input
                                value={concept.label}
                                onChangedValue={this.filterConceptScreenLabel}
                                placeholder={formatString(
                                    FilterOnX,
                                    ConceptScreenLabel,
                                ).toLowerCase()}
                                data-ft-component="conceptScreenLabelFilter"
                            />
                        </FieldItems>
                    </Cell>
                    <Cell>
                        <FieldItems>
                            <Input
                                value={concept.code}
                                onChangedValue={this.filterConceptCode}
                                placeholder={formatString(
                                    FilterOnX,
                                    ConceptCode,
                                ).toLowerCase()}
                                data-ft-component="conceptCodeFilter"
                            />
                        </FieldItems>
                    </Cell>
                    <Cell>
                        <FieldItems>
                            <Input
                                value={workspace.label}
                                onChangedValue={this.filterWorkspaceScreenLabel}
                                placeholder={formatString(
                                    FilterOnX,
                                    WorkspaceScreenLabel,
                                ).toLowerCase()}
                                data-ft-component="workspaceScreenLabelFilter"
                            />
                        </FieldItems>
                    </Cell>
                    <Cell>
                        <FieldItems>
                            <Input
                                value={workspace.code}
                                onChangedValue={this.filterWorkspaceCode}
                                placeholder={formatString(
                                    FilterOnX,
                                    WorkspaceCode,
                                ).toLowerCase()}
                                data-ft-component="workspaceCodeFilter"
                            />
                        </FieldItems>
                    </Cell>
                    <Cell>
                        <Checkbox
                            data-ft-component="instanceFilter"
                            isRequired={true}
                            isChecked={includeInstances}
                            onChecked={(): void => {
                                this.filterInstances(true)
                            }}
                            onUnchecked={(): void => {
                                this.filterInstances(false)
                            }}
                        />
                    </Cell>
                    <Cell>
                        <Checkbox
                            data-ft-component="activeFilter"
                            isRequired={true}
                            isChecked={isActive}
                            onChecked={(): void => {
                                this.filterActive(true)
                            }}
                            onUnchecked={(): void => {
                                this.filterActive(false)
                            }}
                        />
                    </Cell>
                </HeaderRow>
            </Header>
        )
    }

    filterConceptScreenLabel = (label: string): void => {
        const { filter, filterConcepts } = this.props
        filterConcepts({ ...filter, concept: { ...filter.concept, label } })
    }

    filterConceptCode = (code: string): void => {
        const { filter, filterConcepts } = this.props
        filterConcepts({ ...filter, concept: { ...filter.concept, code } })
    }

    filterWorkspaceScreenLabel = (label: string): void => {
        const { filter, filterConcepts } = this.props
        filterConcepts({ ...filter, workspace: { ...filter.workspace, label } })
    }

    filterWorkspaceCode = (code: string): void => {
        const { filter, filterConcepts } = this.props
        filterConcepts({ ...filter, workspace: { ...filter.workspace, code } })
    }

    filterInstances = (includeInstances: boolean): void => {
        const { filter, filterConcepts } = this.props
        filterConcepts({ ...filter, includeInstances })
    }

    filterActive = (isActive: boolean): void => {
        const { filter, filterConcepts } = this.props
        filterConcepts({ ...filter, isActive })
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.conceptsPage.conceptsInfo,
})

export default connect(mapStateToProps, mapDispatchToProps)(ConceptTableHeader)
